"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUploads = void 0;
var react_1 = __importStar(require("react"));
var helpers_1 = require("../../helpers");
function reducer(state, action) {
    switch (action.type) {
        case 'CLEAR_UPLOADS':
            return __assign(__assign({}, state), { uploads: [] });
        case 'ADD_UPLOAD':
            return __assign(__assign({}, state), { uploads: __spread(state.uploads, [action.id]) });
        case 'REMOVE_UPLOAD':
            return __assign(__assign({}, state), { uploads: state.uploads.filter(function (id) { return id !== action.id; }) });
        default:
            throw new Error();
    }
}
var _a = __read(helpers_1.createContext(), 2), hook = _a[0], Provider = _a[1];
var UploadsProvider = function (_a) {
    var children = _a.children;
    var _b = __read(react_1.useReducer(reducer, { uploads: [] }), 2), state = _b[0], dispatch = _b[1];
    var clearUploads = react_1.useCallback(function () {
        dispatch({ type: 'CLEAR_UPLOADS' });
    }, []);
    var addUpload = react_1.useCallback(function (id) {
        dispatch({ type: 'ADD_UPLOAD', id: id });
    }, []);
    var removeUpload = react_1.useCallback(function (id) {
        dispatch({ type: 'REMOVE_UPLOAD', id: id });
    }, []);
    return (react_1.default.createElement(Provider, { value: __assign(__assign({}, state), { clearUploads: clearUploads,
            addUpload: addUpload,
            removeUpload: removeUpload }) }, children));
};
exports.useUploads = hook;
exports.default = UploadsProvider;
//# sourceMappingURL=UploadsProvider.js.map